<script>
import {
  SubscriptionPaymentCardElementMixin,
} from "%/dynamic-component-editor/standard-components/subscription-payment-card/subscription-payment-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "SubscriptionPaymentPlanName",
  elementPanelSettings: {
    displayName: "Payment Plan Name",
    displayIcon: "text-alt",
    elementGroup: "subscriptionPaymentElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SubscriptionPaymentCardElementMixin],
  computed: {
    value() {
      return this.entity.subscriptionPlanName ?? "";
    },
  },
};
</script>
